import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import OutlinedSelect from '../../../controls/OutlinedSelect';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';

const styles = () => ({
    whiteBackground: {
        backgroundColor: 'white',
    },
    grey: {
        color: grey[600],
    },
});

class AlertDetails extends React.Component {
    render() {
        const messageTypes = [
            { label: 'Error', value: 'error' },
            { label: 'Warning', value: 'warning' },
            { label: 'Info', value: 'info' },
            { label: 'Success', value: 'success' },
        ];

        return (
            <React.Fragment>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <TextField
                            id="title"
                            value={this.props.field.title}
                            multiline
                            variant="outlined"
                            label="Title"
                            fullWidth
                            className={this.props.classes.whiteBackground}
                            onChange={this.props.handleChange}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <OutlinedSelect
                            id="alertType"
                            name="alertType"
                            fullWidth
                            value={this.props.field.alertType}
                            onChange={this.props.handleChange}
                            className={this.props.classes.whiteBackground}
                            onBlur={this.props.handleChange}
                            label="Message Type"
                        >
                            {messageTypes.map((choice) => (
                                <MenuItem key={choice.value} value={choice.value}>
                                    {choice.label}
                                </MenuItem>
                            ))}
                        </OutlinedSelect>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            id="text"
                            multiline
                            className={this.props.classes.whiteBackground}
                            margin="normal"
                            variant="outlined"
                            rows={4}
                            fullWidth
                            value={this.props.field.text}
                            onChange={this.props.handleChange}
                            label="Message"
                        />
                    </Grid>
                </Grid>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(AlertDetails);
